<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask" @keyup.esc='close' @click="close">
      <div class="modal-wrapper">
        <div id="js-modalContainer" class="modal-container" :style="`width: ${width}`" @click.stop>
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <button type="button" @click="close" class="btn btn-default">{{ $t("close") }}</button>
            <slot name="footer">
              default footer
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  methods: {
    onClose() {
      this.close();
    },
  },
  props: { close: Function, width: { type: String, default: '' } },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 103%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: block;
  overflow-y: scroll;
  transition: opacity .3s ease;
}

.modal-wrapper {
  vertical-align: middle;
}

.modal-container {
  overflow-y: auto;
  max-height: 99%;
  width: 600px;
  margin: 30px auto 0;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-wide .modal-container {
  width: 900px;
}

@media only screen and (max-width: 700px) {
  .modal-wide .modal-container {
    width: auto;
  }
}

.modal-container::-webkit-scrollbar {
    display: none;
}

.modal-header h3 {
  margin-top: 0;
  color: #5597cd;
}


.modal-default-button {
  float: right;
}

.modal-footer {
  display: inherit;
  right: 0;
}

.modal-footer button {
  margin: 5px;
}

@media only screen and (max-width: 700px) {
  .modal-container {
    width: auto;
    margin: 0px 10px;
    padding: 0;
    height: 95%;
  }
}
@media only screen and (max-width: 400px) {
  .modal-container {
    margin: 0px;
  }
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-wide-img {
  width: 100%;
}

@media only screen and (max-width: 360px) {
  .recaptcha{
    transform: scale(0.85);
    transform-origin: left;
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?8acb4414